import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

const LanguageSwitcher = () => {
    const { i18n } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);

    const languages = [
        { code: 'pl', label: 'PL', flag: '🇵🇱', name: 'Polski' },
        { code: 'en', label: 'EN', flag: '🇬🇧', name: 'English' },
        { code: 'de', label: 'DE', flag: '🇩🇪', name: 'Deutsch' },
        { code: 'fr', label: 'FR', flag: '🇫🇷', name: 'Français' },
        { code: 'uk', label: 'UA', flag: '🇺🇦', name: 'Українська' },
        { code: 'cs', label: 'CZ', flag: '🇨🇿', name: 'Čeština' },
    ];

    const currentLang = languages.find(lang => lang.code === i18n.language) || languages[0];

    const changeLanguage = (code) => {
        i18n.changeLanguage(code);
        setIsOpen(false);
    };

    return (
        <div className="language-switcher">
            <button
                className="lang-btn"
                onClick={() => setIsOpen(!isOpen)}
                aria-label="Change language"
            >
                <span className="lang-flag">{currentLang.flag}</span>
                <span className="lang-code">{currentLang.label}</span>
                <span className={`chevron ${isOpen ? 'open' : ''}`}>▼</span>
            </button>

            {isOpen && (
                <div className="lang-dropdown">
                    {languages.map((lang) => (
                        <button
                            key={lang.code}
                            className={`lang-option ${i18n.language === lang.code ? 'active' : ''}`}
                            onClick={() => changeLanguage(lang.code)}
                        >
                            <span className="lang-flag">{lang.flag}</span>
                            <span className="lang-name">{lang.name}</span>
                        </button>
                    ))}
                </div>
            )}
        </div>
    );
};

export default LanguageSwitcher;
